import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";

/**
 * WordPress dependencies
 */
import { registerStore } from '@wordpress/data';
import { controls as dataControls } from '@wordpress/data-controls';
/**
 * Internal dependencies
 */

import reducer from './reducer';
import applyMiddlewares from './middlewares';
import * as selectors from './selectors';
import * as actions from './actions';
import controls from './controls';
import { STORE_KEY } from './constants';
/**
 * Post editor data store configuration.
 *
 * @see https://github.com/WordPress/gutenberg/blob/master/packages/data/README.md#registerStore
 *
 * @type {Object}
 */

export var storeConfig = {
  reducer: reducer,
  selectors: selectors,
  actions: actions,
  controls: _objectSpread({}, dataControls, controls)
};
var store = registerStore(STORE_KEY, _objectSpread({}, storeConfig, {
  persist: ['preferences']
}));
applyMiddlewares(store);
export default store;
//# sourceMappingURL=index.js.map